/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
// var radio = require('ES/lib/radio');
var FormMixin = require('ES/widgets/forms/FormMixin');
var RadioMixin = require('ES/utils/RadioMixin');
var ErrorAlert = require('ES/widgets/ErrorAlert');
var LoadingWrap = require('ES/widgets/LoadingWrap');
var VerticalFields = require('ES/widgets/VerticalFields');
var AuthedUserSession = require('../../../utils/AuthedUserSession');
var reloadDisplaylists = require("../../../utils/reloadDisplaylists");
var reloadSitelists = require("../../../utils/reloadSitelists");

module.exports = dd.createClass({
    mixins: [RadioMixin],
    getInitialState: function () {
        return {saving: false, error_msg: null, sitelists_reloaded: false, displaylists_reloaded: false};
    },
    componentWillMount: function () {
        var self = this;
        self.radio = {
            Displaylists_get: function () {
                self.setState({saving: true, error_msg: null, displaylists_reloaded: false});
            },
            Displaylists_get_succeeded: function () {
                self.setState({saving: false, displaylists_reloaded: true});
            },
            Displaylists_get_failed: function (message) {
                self.setState({saving: false, error_msg: 'Failed to clear the cache: ' + message, displaylists_reloaded: false});
            },
            Sitelists_get: function () {
                self.setState({saving: true, error_msg: null, sitelists_reloaded: false});
            },
            Sitelists_get_succeeded: function () {
                self.setState({saving: false, sitelists_reloaded: true});
            },
            Sitelists_get_failed: function (message) {
                self.setState({saving: false, error_msg: 'Failed to clear the cache: ' + message, sitelists_reloaded: false});
            },
        };
    },
    __onSubmit: function (data) {
        reloadDisplaylists();
        reloadSitelists();
    },
    render: function () {
        var Displaylists = this.props.Displaylists;

        return LoadingWrap({is_loading: _.isEmpty(Displaylists) || this.state.saving, glass: true},
            dd.div({className: 'Preferences'},
                dd.h2({style: {marginTop: 0}}, 'Advanced Settings'),
                ErrorAlert({message: this.state.error_msg}),
                (this.state.sitelists_reloaded && this.state.displaylists_reloaded) ? dd.div({className: 'alert alert-success'}, "Cache has been cleared successfully. You will need to sign in again. RELOAD the page to complete the process.") : null,
                DaForm({Displaylists: Displaylists, onSubmit: this.__onSubmit})
            )
        );
    }
});

var DaForm = dd.createClass({
    mixins: [FormMixin],
    getInitialValuesSourceVersion: function (props) {
        var Displaylists = props.Displaylists;
        return AuthedUserSession.MY_USERNAME + JSON.stringify(Displaylists && Displaylists.user && Displaylists.user.myevents_preferences);
    },
    getInitialValues: function (props) {
        return {};
    },
    buildFields: function () {
        return {};
    },
    render: function () {
        return dd.form({className: '', onSubmit: this._form_onSubmit},
            dd.div({className: 'row'},
                dd.div({className: 'col-sm-12'}, dd.p({}, "You can clear the saved cache below.  You will download updated settings, action lists, templates, and other company data on your next refresh."))
            ),
            dd.div({className: 'row'},
                dd.div({className: 'col-sm-12'}, VerticalFields.FormButtons({scale: 'md', submit_btn_text: "Clear Cache"}))
            )
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/account_settings/advanced/index.js